(function () {
  'use strict';

  var selector = '#root #content .l4ft.mobile-compact, #root #content .l4cl.slider:not(.mobile-scroll)';

  function update(scroller, indicator) {
    var maximum = scroller.scrollWidth - scroller.clientWidth;
    var progress = maximum > 0 ? Math.min(1, Math.max(0, scroller.scrollLeft / maximum)) : 1;
    indicator.style.setProperty('--dw-scroll-progress', (progress * 100) + '%');
    indicator.style.setProperty('--dw-scroll-active', (50 + (progress * 50)) + '%');
    indicator.hidden = maximum <= 1;
    indicator.setAttribute('aria-valuenow', Math.round(progress * 100));
  }

  function initialize(scroller) {
    if (scroller.dataset.dwScrollProgress === 'true') return;
    scroller.dataset.dwScrollProgress = 'true';

    var indicator = document.createElement('div');
    indicator.className = 'dw-scroll-progress';
    indicator.setAttribute('role', 'scrollbar');
    indicator.setAttribute('aria-label', 'Horizontal slider position');
    indicator.setAttribute('aria-valuemin', '0');
    indicator.setAttribute('aria-valuemax', '100');
    indicator.setAttribute('tabindex', '0');
    scroller.insertAdjacentElement('afterend', indicator);

    var refresh = function () { update(scroller, indicator); };
    var seek = function (clientX) {
      var bounds = indicator.getBoundingClientRect();
      var ratio = Math.min(1, Math.max(0, (clientX - bounds.left) / bounds.width));
      scroller.scrollLeft = ratio * (scroller.scrollWidth - scroller.clientWidth);
    };
    var dragging = false;
    indicator.addEventListener('pointerdown', function (event) {
      dragging = true;
      scroller.classList.add('dw-track-dragging');
      indicator.setPointerCapture(event.pointerId);
      seek(event.clientX);
    });
    indicator.addEventListener('pointermove', function (event) {
      if (dragging) seek(event.clientX);
    });
    var stopDragging = function () {
      dragging = false;
      scroller.classList.remove('dw-track-dragging');
    };
    indicator.addEventListener('pointerup', stopDragging);
    indicator.addEventListener('pointercancel', stopDragging);
    indicator.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var direction = event.key === 'ArrowRight' ? 1 : -1;
      scroller.scrollBy({ left: direction * scroller.clientWidth * 0.7, behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(scroller);
    requestAnimationFrame(refresh);
  }

  function initializeAll() {
    document.querySelectorAll(selector).forEach(initialize);
  }

  document.addEventListener('DOMContentLoaded', initializeAll);
  new MutationObserver(initializeAll).observe(document.documentElement, { childList: true, subtree: true });
})();
